const aceEditorStyles = (colors) => `
 .ace_editor {
    border: 1px solid ${colors.input.border} !important;
    border-radius: 0;
  }

  .ace-graylog {
    background-color: ${colors.global.contentBackground};
    color: ${colors.variant.darkest.default};

    &.ace_multiselect .ace_selection.ace_start {
      box-shadow: 0 0 3px 0 ${colors.global.contentBackground};
    }

    .ace_gutter {
      background: ${colors.variant.lighter.default};
      color: ${colors.variant.darkest.default};
    }

    .ace_print-margin {
      width: 1px;
      background: ${colors.variant.lightest.default};
    }

    .ace_cursor {
      border-color: ${colors.text.primary};
    }

    .ace_marker-layer {
      .ace_selection {
        background: Highlight;
      }

      .ace_step {
        background: rgb(255 255 0);
      }

      .ace_bracket {
        margin: -1px 0 0 -1px;
        border: 1px solid ${colors.gray[70]};
      }

      .ace_selected-word {
        border: 1px solid ${colors.gray[60]};
        background: transparent;
      }

      .ace_active-line {
        background: ${colors.variant.lightest.default};
      }
    }

    .ace_gutter-active-line {
      background-color: ${colors.variant.lightest.default};
    }

    .ace_invisible {
      color: ${colors.gray[70]};
    }

    .ace_keyword,
    .ace_meta,
    .ace_storage,
    .ace_storage.ace_type,
    .ace_support.ace_type {
      color: ${colors.global.link};
    }

    .ace_keyword.ace_operator {
      color: ${colors.variant.darker.info};
    }

    .ace_constant.ace_character,
    .ace_constant.ace_language,
    .ace_constant.ace_numeric,
    .ace_keyword.ace_other.ace_unit,
    .ace_support.ace_constant,
    .ace_variable.ace_parameter {
      color: ${colors.variant.darker.primary};
    }

    .ace_constant.ace_other {
      color: ${colors.variant.darker.default};
    }

    .ace_invalid {
      color: ${colors.global.textAlt};
      background-color: ${colors.variant.light.danger};
    }

    .ace_invalid.ace_deprecated {
      color: ${colors.global.textAlt};
      background-color: ${colors.variant.primary};
    }

    .ace_fold {
      background-color: ${colors.variant.info};
      border-color: ${colors.variant.darkest.default};
    }

    .ace_entity.ace_name.ace_function,
    .ace_support.ace_function,
    .ace_variable {
      color: ${colors.variant.info};
    }

    .ace_support.ace_class,
    .ace_support.ace_type {
      color: ${colors.variant.darker.warning};
    }

    .ace_heading,
    .ace_markup.ace_heading,
    .ace_string {
      color: ${colors.variant.darker.success};
    }

    .ace_entity.ace_name.ace_tag,
    .ace_entity.ace_other.ace_attribute-name,
    .ace_meta.ace_tag,
    .ace_string.ace_regexp,
    .ace_variable {
      color: ${colors.variant.light.danger};
    }

    .ace_comment {
      color: ${colors.text.secondary};
    }

    .ace_tooltip {
      background-color: ${colors.global.background};
      padding: 4px;
      padding-left: 0;
      line-height: 1.5;
      
      .ace_icon {
        margin-right: 3px;
      }
    }
  }
`;
export default aceEditorStyles;
